import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { User } from '@fleetoperate/shared/ui/fleetoperate-toolbar';
import { TabActionLink } from '@fleetoperate/shared/ui/header';
import { ROUTE_SHIPPER_SEARCH } from '../../shared/routes';
import { Router } from '@angular/router';

@Component({
  selector: 'fleetoperate-shipper-prod-support',
  templateUrl: './shipper-prod-support.component.html',
  styleUrls: ['./shipper-prod-support.component.scss']
})
export class ShipperProdSupportComponent implements OnInit {
  title: string = 'Shipper Prod Support';
  user: User;
  actions: Array<TabActionLink> = [];
  backAction: Function;
  logoutSubject: Subject<void> = new Subject<void>();
  viewCtrl = new FormControl();
  views: Object[] = [{ value: 'appStatus', text: 'App Status' }, { value: 'errors', text: 'System Errors' }];
  showShipments: boolean;
  showErrors: boolean;

  constructor(private readonly router: Router) {}

  ngOnInit() {
    this.viewCtrl.valueChanges.subscribe(val => {
      this.showShipments = val === 'appStatus';
      this.showErrors = val !== 'appStatus';
    });
    this.viewCtrl.setValue('appStatus');
    this.backAction = () => {
      this.router.navigate([ROUTE_SHIPPER_SEARCH]);
    };
  }

  onLogout(): void {
    this.logoutSubject.next();
  }
}
